import styled from "styled-components";
import { IconWrapper } from "app/components/DiverseItemIcon/styledComponents";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledIconWrapper = styled(IconWrapper)`
    margin: auto 16px auto 0;
`;

export const StretchedIconContainer = styled(FlexRow)`
    & img {
        width: 20px;
        height: 20px;
    }
`;
